export const CANDIDATE_TABS = {
	on_assignment: 'on-assignment',
	per_diem_eligible: 'per-diem-eligible',
	submission: 'submission',
	matches: 'matches',
	submission_ready: 'submission-ready',
	pre_submission: 'pre-submission',
	shortlist: 'shortlist',
	dismissed: 'dismissed',
}

export const JOB_TABS = {
	available_jobs: 'available-jobs',
	submission: 'submission',
	matches: 'matches',
	active_assignments: 'active-assignments',
	upcoming_assignments: 'upcoming-assignments',
	closed_jobs: 'closed-jobs'
}

export const HOME_TABS = {
	submission: 'submission',
	matches: 'matches',
	pre_submission: 'pre-submission',
}

export const JOB_INFO_TAB = {
	info: 'info',
	toa: 'toa',
	submissions: 'submissions',
	matches: 'matches',
}
